// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TrendInsightIntro_wrap__yqsN5","txt_wrap":"TrendInsightIntro_txt_wrap__3EHsx","img_wrap":"TrendInsightIntro_img_wrap__3rcXb","box":"TrendInsightIntro_box__3nMcD"};